import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CreateShopRequestDTO, ShopResponseDTO } from 'typings/dto/shop';
import IShopActionsService from 'services/storageModelActions/shop/IShopActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class ShopActionsServiceImpl
  extends ModelActionsService<Shop, CreateShopRequestDTO, ShopResponseDTO>
  implements IShopActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.shop.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };
}
